import SearchIcon from '@/icons/bwi/search.svg'
import { useTranslations } from '@/utils/locale'
import { useHelpSearchModal } from '@/pages/help-parent'
import { cx } from '@/utils/strings'
import { getOs } from '@/utils/user-info'

type HelpSearchProps = {
  searchSize?: string
}

export default function HelpSearch({ searchSize }: HelpSearchProps): JSX.Element {
  const { t } = useTranslations()
  const os = getOs()
  const { openSearch } = useHelpSearchModal()

  return (
    <>
      <div className={cx('relative', searchSize !== 'large' && 'max-w-[300px]')}>
        <input
          name="search"
          type="text"
          placeholder={t('What are you looking for?')}
          readOnly
          className={cx(
            'bg-white dark:bg-secondary-700 rounded-full mx-auto w-full placeholder:text-sm placeholder:text-indigoBlue dark:placeholder:text-white px-4 py-2',
            searchSize === 'large' && 'placeholder:text-lg py-4'
          )}
          onKeyDown={(e) => {
            if (e.code === 'Enter' || e.code === 'Space') {
              openSearch()
            }
          }}
          onClick={openSearch}
        />
        <div
          className={cx(
            'absolute top-0 bottom-0 right-4 flex items-center',
            searchSize === 'large' ? 'gap-6' : 'gap-2'
          )}
          onClick={openSearch}
        >
          {['Windows', 'Linux', 'MacOS'].includes(os) && (
            <div className={cx('text-gray-400 hidden md:block', searchSize === 'large' ? 'text-xl' : 'text-sm')}>
              {os === 'MacOS' ? '⌘' : 'Ctrl'} + K
            </div>
          )}
          <SearchIcon className="text-indigoBlue dark:text-secondary-50 m-auto w-4 h-4 lg:w-5 lg:h-5 cursor-pointer" />
        </div>
      </div>
    </>
  )
}
